import { Component, OnInit } from '@angular/core';
import { LoadSpinnerService } from '../../services';

@Component({
    selector: 'load-spinner',
    templateUrl: 'load-spinner.component.html',
    standalone: false
})
export class LoadSpinnerComponent implements OnInit {
  show = false;

  constructor(private spinner: LoadSpinnerService) {}

  ngOnInit() {
    this.spinner.getSpinner().subscribe((show: boolean) => {
      this.show = show;
    });
  }
}
